// const scroll = {
//   behavior: 'smooth',
//   block: 'center',
//   inline: 'center'
// };
const scroll = false;
const defaultProps = {position: 'auto', scroll, positionFixed: true, eventsEnabled: true};
export const HELP_TOUR_TIMEOUT = 3000;
export const helpTourOptions = {useKeyboardNavigation: false, startTimeout: 500};

const workspaceManagementTour = [
  {
    target: '.v-step-create-new-workspace',
    header: {title: 'Create new workspace'},
    content: 'The scenario explorer uses workspaces to group panels by topics. Create a new workspace ' +
      'to start exploring, or select an existing workspace below. You can also save and share workspaces with ' +
      'other users.',
    params: {...defaultProps, placement: 'bottom'},
  },
];

const panelManagementTour = [
  {
    target: '.v-step-add-new-panel',
    header: {title: 'Create new panel'},
    content: 'Start exploring by creating a new panel!',
    params: {...defaultProps, placement: 'right'},
  },
];

const basicFiltersTour = [
  {
    target: '.v-step-panel-metadata',
    header: {title: 'Scenario selection'},
    content: 'Start creating your panel by selecting scenarios. You can select them by pre-defined categories.',
    params: {...defaultProps, placement: 'right'},
  },
  {
    target: '.v-step-panel-modelScenario',
    header: {title: 'Scenario selection'},
    content: 'You can also select scenarios by model or scenario groups.',
    params: {...defaultProps, placement: 'right'},
  },
  {
    target: '.v-step-panel-characteristics',
    header: {title: 'Data selection'},
    content: 'Next, select a timeseries variable that you want to visualise. You can filter available variables by groups.',
    params: {...defaultProps, placement: 'bottom'},
  },
  {
    target: '.v-step-panel-apply',
    header: {title: 'Finish selection'},
    content: 'After you have made your selection, make sure to hit <strong>Apply</strong>.',
    params: {...defaultProps, placement: 'left'},
  },
];

const extraFiltersTour = config => {
  const preselectedRegion = config.timeseriesPanel.tabs.find(tab => tab.key === 'regions').preselected || 'World';
  return [
    {
      target: '.v-step-panel-data',
      header: {title: 'Congratulations!'},
      content: 'You have created a panel...',
      params: {...defaultProps, placement: 'top'},
    },
    {
      target: '.v-step-panel-regions',
      header: {title: 'Region selection'},
      content: 'By default, we select the "' + preselectedRegion + '" region, but you can change that here.',
      params: {...defaultProps, placement: 'bottom'},
    },
    {
      target: '.v-step-panel-options',
      header: {title: 'Panel options'},
      content: 'You can choose additional options here, like defining panel name, description etc.',
      params: {...defaultProps, placement: 'bottom'},
    },
    {
      target: '.v-step-panel-show-as',
      header: {title: 'Data view'},
      content: 'You can change the chart type or display the data as a table here.',
      params: {...defaultProps, placement: 'bottom'},
    },
    {
      target: '.v-step-panel-download',
      header: {title: 'Data download'},
      content: 'You can download your panel or the underlying data in multiple formats here.',
      params: {...defaultProps, placement: 'bottom'},
    },
    {
      target: '.v-step-add-new-panel',
      header: {title: 'Add another panel'},
      content: 'Click here to add another panel to this workspace',
      params: {...defaultProps, placement: 'right'},
    },
    {
      target: '.v-step-cross-panel-linking',
      header: {title: 'Multiple panels'},
      content: 'You can easily identify models, scenarios or variables across panels and tables by using the "cross-panel highlighting" feature.',
      params: {...defaultProps, placement: 'bottom'},
    },
    {
      target: '.help-button',
      header: {title: 'Help'},
      content: 'Click here to restart the tour.',
      params: {...defaultProps},
    },
  ];
};

const expandPanelsTour = [
  {
    target: '.v-step-expand-panel',
    header: {title: 'Common controls'},
    content: 'Use this button to expand panel.',
    params: {...defaultProps, placement: 'bottom'},
  },
];

const textPanelTour = [
  {
    target: '.v-step-edit',
    header: {title: 'Text panel'},
    content: 'Use this button to edit panel content.',
    params: {...defaultProps, placement: 'bottom'},
  },
];

const helpTour = [
  {
    target: '.help-button',
    header: {title: 'Help'},
    content: 'Click here to restart the tour later.',
    params: {...defaultProps},
  },
];

export default {
  workspaceManagementTour,
  panelManagementTour,
  basicFiltersTour,
  extraFiltersTour,
  helpTour,
  expandPanelsTour,
  textPanelTour,
};
